export default __webpack_public_path__ + "static/media/openEye.b9438428.svg";